import { render } from "./BulkUpdate.vue?vue&type=template&id=306bff2f&scoped=true"
import script from "./BulkUpdate.vue?vue&type=script&lang=js"
export * from "./BulkUpdate.vue?vue&type=script&lang=js"

import "./BulkUpdate.vue?vue&type=style&index=0&id=306bff2f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306bff2f"]])

export default __exports__